import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import FloatingDonateButton from './components/ui/FloatingDonateButton';

// Homepage loads eagerly (first paint)
import Homepage from './pages/homepage';

// Everything else loads lazily (code-split)
const SearchResults = lazy(() => import('./pages/search-results'));
const IndividualProfile = lazy(() => import('./pages/individual-profile'));
const CompanyProfile = lazy(() => import('./pages/company-profile'));
const Shareholders = lazy(() => import('./pages/shareholders'));
const PACDirectory = lazy(() => import('./pages/pac-directory'));
const PACProfile = lazy(() => import('./pages/pac-profile'));
const AboutPage = lazy(() => import('./pages/about'));
const ContactPage = lazy(() => import('./pages/contact'));
const AdManagementDashboard = lazy(() => import('./pages/ad-management-dashboard'));
const AgentDashboard = lazy(() => import('./pages/agent-dashboard'));
const AdminPanel = lazy(() => import('./pages/admin'));
const DonatePage = lazy(() => import('./pages/donate'));
const ContributePage = lazy(() => import('./pages/contribute'));
const LogoWall = lazy(() => import('./pages/logo-wall'));
const LogoScan = lazy(() => import('./pages/logo-scan'));
const PrivacyPolicyPage = lazy(() => import('./pages/privacy-policy'));
const TermsPage = lazy(() => import('./pages/terms'));
const NotFound = lazy(() => import('./pages/NotFound'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-3">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
      <span className="text-muted-foreground text-sm">Loading...</span>
    </div>
  </div>
);

function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <RouterRoutes>
            <Route path="/" element={<Homepage />} />
            <Route path="/search-results" element={<SearchResults />} />
            <Route path="/individual-profile" element={<IndividualProfile />} />
            <Route path="/company-profile" element={<CompanyProfile />} />
            <Route path="/shareholders" element={<Shareholders />} />
            <Route path="/pac-directory" element={<PACDirectory />} />
            <Route path="/pac-profile" element={<PACProfile />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/ad-management" element={<AdManagementDashboard />} />
            <Route path="/agent-dashboard" element={<AgentDashboard />} />
            {/* Obfuscated admin route — not linked anywhere public */}
            <Route path="/wymrad32333" element={<AdminPanel />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/contribute" element={<ContributePage />} />
            <Route path="/logo-wall" element={<LogoWall />} />
            <Route path="/logo-scan" element={<LogoScan />} />
            <Route path="/privacy_policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </Suspense>
        <FloatingDonateButton />
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default Routes
